module.exports = __webpack_public_path__ + "static/media/guide_2_1.c9603914.png";